import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import kexCommunityState from './state';
export const kexCommunitySlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => kexCommunityState);
    },
    initialState: kexCommunityState,
    name: 'kexCommunity',
    reducers: {
        errorReceiveKEXCommunity: state => {
            state.kexCommunity = undefined;
            state.requestingKEXCommunity = false;
        },
        failedReceiveKEXCommunity: state => {
            state.kexCommunity = undefined;
            state.requestingKEXCommunity = false;
        },
        receiveKEXCommunity: {
            prepare: kexCommunity => {
                return {
                    payload: {
                        kexCommunity
                    }
                };
            },
            reducer: (state, action) => {
                const { kexCommunity } = action.payload;
                state.kexCommunity = kexCommunity;
                state.requestingKEXCommunity = false;
            }
        },
        requestKEXCommunity: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingKEXCommunity = true;
            }
        },
        resetKEXCommunity: () => kexCommunityState
    }
});
export const { errorReceiveKEXCommunity, failedReceiveKEXCommunity, receiveKEXCommunity, requestKEXCommunity, resetKEXCommunity } = kexCommunitySlice.actions;
export default kexCommunitySlice.reducer;
